module.exports = __webpack_public_path__ + "static/media/discount-applied-sticker.e37b4b99.svg";